import React from 'react';
// Components
import ManageAmaRequests from 'components/common/ManageAmaRequests';

const ManageOrganizationAmaRequests: React.FC = () => {
  return <ManageAmaRequests />;
};

export default ManageOrganizationAmaRequests;
